<template>
  <section class="sec sec-alt" id="writing">
    <div class="sec-inner">
      <div class="sec-head">
        <div class="sec-eyebrow">写作</div>
        <h2 class="sec-title">十年技术写作</h2>
        <p class="sec-sub">
          2016 年起在 CSDN 持续更新，从实战问题、源码分析到任教时整理的讲义，均有沉淀。
        </p>
      </div>

      <div class="csdn-card">
        <div class="csdn-top">
          <div>
            <div class="csdn-name">{{ csdn.name }}</div>
            <div class="csdn-meta">{{ csdn.joined }}注册 · {{ csdn.handle }}</div>
          </div>
          <a class="csdn-go" :href="csdn.link" target="_blank" rel="noopener">
            去看看 &rarr;
          </a>
        </div>

        <div class="csdn-stats">
          <div class="cs" v-for="s in csdn.stats" :key="s.label">
            <div class="cs-value">{{ s.value }}</div>
            <div class="cs-label">{{ s.label }}</div>
          </div>
        </div>

        <div class="csdn-badges">
          <span v-for="b in csdn.badges" :key="b">{{ b }}</span>
        </div>

        <div class="csdn-cols">
          <div class="csdn-cols-head">写得最多的几个方向</div>
          <div class="cols-list">
            <a
              class="col-item"
              v-for="c in csdn.columns"
              :key="c.name"
              :href="csdn.link"
              target="_blank"
              rel="noopener"
            >
              <span class="col-name">{{ c.name }}</span>
              <span class="col-count">{{ c.count }}</span>
            </a>
          </div>
        </div>
      </div>

      <div class="mp-head">两个公众号</div>
      <div class="accounts-row">
        <div class="mp" v-for="a in accounts" :key="a.name">
          <div class="mp-left">
            <div class="mp-top">
              <img class="mp-avatar" :src="a.avatar" :alt="a.name" data-zoom />
              <div>
                <div class="mp-name">{{ a.name }}</div>
                <div class="mp-sub">{{ a.location }} · {{ a.posts }}</div>
              </div>
            </div>
            <p class="mp-desc">{{ a.desc }}</p>
            <div class="mp-fans">
              <strong>{{ a.followers }}</strong> 关注
            </div>
          </div>
          <div class="mp-right">
            <img class="mp-qr" :src="a.qrcode" :alt="a.name + ' 二维码'" data-zoom />
            <div class="mp-qr-tip">微信扫码关注</div>
          </div>
        </div>
      </div>
      <p class="community-note">
        另运营全国长护险交流群（鼠、牛、虎三群，成员 1500+，兔群筹备中）与长护险专业知识库（1000+ 人加入）。
      </p>
    </div>
  </section>
</template>

<script>
import { writing, accounts } from "@/assets/js/profile";

export default {
  name: "WritingSection",
  data() {
    return { csdn: writing.csdn, accounts };
  }
};
</script>

<style scoped>
.sec-head {
  margin-bottom: 40px;
}
.csdn-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 34px 32px;
}
.csdn-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;
}
.csdn-name {
  font-size: 20px;
  font-weight: 600;
  color: var(--ink);
}
.csdn-meta {
  font-size: 13.5px;
  color: var(--ink-faint);
  margin-top: 6px;
}
.csdn-go {
  font-size: 14.5px;
  font-weight: 500;
  color: var(--accent);
}
.csdn-go:hover {
  color: var(--accent-deep);
}
.csdn-stats {
  display: flex;
  flex-wrap: wrap;
  margin-top: 28px;
  padding-top: 26px;
  border-top: 1px solid var(--border-soft);
}
.cs {
  flex: 1 1 130px;
  min-width: 110px;
}
.cs-value {
  font-size: 30px;
  font-weight: 600;
  color: var(--ink);
  letter-spacing: -0.8px;
}
.cs-label {
  font-size: 13px;
  color: var(--ink-soft);
  margin-top: 5px;
}
.csdn-badges {
  display: flex;
  flex-wrap: wrap;
  margin-top: 26px;
}
.csdn-badges span {
  font-size: 12.5px;
  color: var(--accent-deep);
  background: var(--accent-wash);
  border-radius: 6px;
  padding: 5px 12px;
  margin: 0 8px 8px 0;
}
.csdn-cols {
  margin-top: 26px;
  padding-top: 24px;
  border-top: 1px solid var(--border-soft);
}
.csdn-cols-head {
  font-size: 13px;
  letter-spacing: 1.5px;
  color: var(--ink-faint);
  margin-bottom: 14px;
}
.cols-list {
  display: flex;
  flex-wrap: wrap;
}
.col-item {
  display: inline-flex;
  align-items: baseline;
  border: 1px solid var(--border);
  border-radius: 20px;
  padding: 6px 14px;
  margin: 0 9px 9px 0;
  transition: border-color 0.18s ease;
}
.col-item:hover {
  border-color: var(--accent);
}
.col-name {
  font-size: 13.5px;
  color: var(--ink-mid);
}
.col-count {
  font-size: 12px;
  color: var(--ink-faint);
  margin-left: 8px;
}

.mp-head {
  font-size: 13px;
  letter-spacing: 1.5px;
  color: var(--ink-faint);
  margin: 40px 0 16px;
}
.accounts-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 18px;
}
.mp {
  display: flex;
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 24px 24px 22px;
}
.mp-left {
  flex: 1 1 auto;
  min-width: 0;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
}
.mp-top {
  display: flex;
  align-items: center;
  margin-bottom: 14px;
}
.mp-avatar {
  cursor: zoom-in;
  width: 46px;
  height: 46px;
  border-radius: 50%;
  border: 1px solid var(--border);
  margin-right: 12px;
  flex: 0 0 auto;
  object-fit: cover;
}
.mp-name {
  font-size: 17px;
  font-weight: 600;
  color: var(--ink);
}
.mp-sub {
  font-size: 12.5px;
  color: var(--ink-faint);
  margin-top: 3px;
}
.mp-desc {
  font-size: 13.5px;
  line-height: 1.85;
  color: var(--ink-soft);
  margin: 0 0 14px;
  flex: 1 1 auto;
}
.mp-fans {
  font-size: 13px;
  color: var(--ink-soft);
}
.mp-fans strong {
  font-size: 19px;
  font-weight: 600;
  color: var(--accent);
  margin-right: 3px;
}
.mp-right {
  flex: 0 0 108px;
  text-align: center;
}
.mp-qr {
  cursor: zoom-in;
  width: 108px;
  height: 108px;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  display: block;
}
.mp-qr-tip {
  font-size: 11.5px;
  color: var(--ink-faint);
  margin-top: 7px;
}

@media (max-width: 760px) {
  .csdn-card {
    padding: 26px 20px;
  }
  .cs {
    flex: 1 1 45%;
    margin-bottom: 16px;
  }
  .cs-value {
    font-size: 24px;
  }
  .accounts-row {
    grid-template-columns: 1fr;
  }
  .mp {
    flex-direction: column;
  }
  .mp-left {
    padding-right: 0;
  }
  .mp-right {
    flex: 0 0 auto;
    text-align: left;
    margin-top: 16px;
  }
}
.community-note {
  margin-top: 22px;
  font-size: 14px;
  line-height: 2;
  color: var(--ink-soft);
}
</style>
